export default __webpack_public_path__ + "static/media/40186.5a5eaba3.jpg";